import { render, staticRenderFns } from "./ClientSearch.vue?vue&type=template&id=0becfc34&scoped=true&"
import script from "./ClientSearch.vue?vue&type=script&lang=js&"
export * from "./ClientSearch.vue?vue&type=script&lang=js&"
import style0 from "./ClientSearch.vue?vue&type=style&index=0&id=0becfc34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0becfc34",
  null
  
)

export default component.exports